import { pushEvent } from '../services/dataLayer';

/**
 * Function to push events to gtag
 * @param {String} event
 * @param {Object} [params] - optional extra parameters object to be sent to gtag
 */
export function trackEvent(event: string, params: Record<string, any> = {}) {
    return pushEvent({
        ...params,
        event,
    });
}
